module.exports = __webpack_public_path__ + "static/img/preview-01.ccf6b29e.webp";